import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AuthCredentials, PersistAuthSettings } from '../../models/auth.model';
import { User } from '../../models/user.model';

export const AuthSessionActions = createActionGroup({
  source: 'Auth',
  events: {
    Login: props<AuthCredentials>(),
    'Login Success': props<{ user: User }>(),
    'Login Failure': props<{ error: string }>(),
    Logout: emptyProps(),
    'Logout Success': props<{ isSso: boolean }>(),
    'Logout Failure': props<{ error: string }>(),
    Hydrate: emptyProps(),
    'Hydrate Failure': emptyProps(),
    'Hydrate Success': props<{ user: User }>(),
    Rehydrate: props<PersistAuthSettings>(),
    'Clear State': emptyProps(),
  },
});
